import { cn } from '@/utils/tailwind';

export const LayoutOrderColumn = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn('grid h-full min-h-0 w-full overflow-x-hidden px-[20px]', className)}
      style={{ gridTemplateRows: '1fr auto' }}
    >
      {children}
    </div>
  );
};
